module.exports = __webpack_public_path__ + "img/ring_a-2097@2x.0ae0eb0.jpg";